import reglementCampagneApi from '@/api/reglement-campagne.api'

const module = {
  namespaced: true,

  state: {
    reglementCampagne: null,
    pdfReglementCampagne: null
  },

  getters: {
    reglementCampagne (state) {
      return state.reglementCampagne
    },
    pdfReglementCampagne (state) {
      return state.pdfReglementCampagne
    }
  },
  mutations: {
    UPDATE_REGLEMENT_CAMPAGNE (state, reglementCampagne) {
      state.reglementCampagne = reglementCampagne
    },
    UPDATE_PDF_REGLEMENT_CAMPAGNE (state, pdfReglementCampagne) {
      state.pdfReglementCampagne = pdfReglementCampagne
    }
  },
  actions: {
    getReglementCampagne ({ commit }, { anneeRecolte, codeGraineRs3 }) {
      return reglementCampagneApi.getReglementCampagne(anneeRecolte, codeGraineRs3)
        .then((result) => {
          commit('UPDATE_REGLEMENT_CAMPAGNE', result)
        })
    },

    telechargerDocumentPdf ({ commit }, reglementCampagne) {
      return reglementCampagneApi.telechargerDocumentPdf(reglementCampagne.id)
        .then((result) => {
          commit('UPDATE_PDF_REGLEMENT_CAMPAGNE', result)
        })
    }
  }
}

export default module
